import script from "./whr-home-news.vue?vue&type=script&setup=true&lang=js"
export * from "./whr-home-news.vue?vue&type=script&setup=true&lang=js"

import "./whr-home-news.vue?vue&type=style&index=0&id=77f34572&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77f34572"]])

export default __exports__